import type { FaireProductEntity } from "../../entity_types/product";

export const p_9szgntsaza: FaireProductEntity = {
  token: "p_9szgntsaza",
  type: "product",
  name: "Cozy Solid Two Tone Tassel Scarf",
  brandToken: "b_5c0ij053zo",
  brandName: "Leto Accessories",
  imageUrl:
    "https://cdn.faire.com/fastly/f32bd9878ead93a3f0af798b132b2ddb475a3bd06db9b566c9123c0ffe380657.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/baed7f4d80f2a9f612773623ff6a24f099bb4a691a66cf3858f53feda924e044.jpeg",
    "https://cdn.faire.com/fastly/4ccfc629fbc43ebb548d2e5c39dccb405d89f46ddcf82efa0b40014876bc8457.jpeg",
    "https://cdn.faire.com/fastly/82d6f369e76a006da22d48d9d3fe595613ccd53a9fd8412b032bc6e3f87cc261.jpeg",
    "https://cdn.faire.com/fastly/85d1b518f13cc8b0f04cb73b028db1333dfab7dc8c3d0df8a1cb97a4091312b8.jpeg",
    "https://cdn.faire.com/fastly/b17ee9754a529dfdfb5ad73cea3f879e06e0b11fd5fd2d20a5c86bf2ec77af7c.jpeg",
    "https://cdn.faire.com/fastly/a9e7f6d6d690b68568e880ea2fa1b60584822c6f8279b74a19d1b690620da12e.jpeg",
    "https://cdn.faire.com/fastly/63ee54fd594acc1db3a50118d2b56b8001fe9bf2a73f6ed09ceb3d4d29f15df4.jpeg",
    "https://cdn.faire.com/fastly/6233a934f2ddd64258e353bec755357ac9429554d8f1c86a806a588761402d53.jpeg",
    "https://cdn.faire.com/fastly/255afa3e1eee14e26cb448fe33641edb7dd9c37d5a71d8f49d8868046040ebb0.jpeg",
    "https://cdn.faire.com/fastly/33277a0a7340363141c7bdb43d102db97f25216ab4df1b01c464f32d91b3208a.jpeg",
    "https://cdn.faire.com/fastly/8272cf1c1858edb63037f3e257f28056ea39d4c289b0a9cf7898d38afde72455.jpeg",
  ],
  priceDollars: 6.5,
  description:
    'Wrap yourself in warmth and style with our Cozy Solid Two Tone Tassel Scarf. Featuring a chic blend of two colors, this scarf adds a subtle yet elegant touch to any outfit. The soft fabric and playful tassels make it the perfect accessory for chilly days. Whether you\'re dressing up or keeping it casual, this scarf is a versatile must-have!\n\nWholesale\nPack of 6 by color\nImmediate Shipping\nOne Size\n100% Polyester\nLength: 82"\nTassel: 7.5"',
  tags: [],
  msrpDollars: 13,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-05-06T17:55:46.183Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
